import { getCredentials } from "app/utils/auth";

export const shouldFetchNavlogs = state => {
	const { token } = getCredentials(state.shop);
	return token && state.partner.enableNavLog;
};
